export default __webpack_public_path__ + "27e35f18d6aca8355f98a9832107e3ab.svg";